<template>
  <div>
    <sc-page-base
    :loading="loading"
    :title="title">
      <div class="columns">
        <div class="column">
          <sc-button
            theme="primary"
            @click="getTableGereratedQuoteContract()">
            Atualizar lista
          </sc-button>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="box">
            <sc-table
              :data="extrationTable"
              :bordered="true"
              class="sc-files__table"
              :hoverable="false"
              draggable
              :show-detail-icon="true">
              <template slot="filters" slot-scope="{ filters }">
                <div class="columns">
                  sdfdsfdsfdsfdsf
                </div>
              </template>
                <template slot-scope="props">

                  <sc-table-column
                    field="download_url"
                    label="Arquivo">
                      {{ props.row.file_name }}
                  </sc-table-column>

                  <sc-table-column
                    field="contract_id"
                    label="ID do Contrato"
                    sortable>
                      {{ props.row.contract_id }}
                  </sc-table-column>

                  <sc-table-column
                    field="delivery_method_id"
                    label="ID de transportadora"
                    sortable>
                      {{ props.row.delivery_method_id }}
                  </sc-table-column>

                  <sc-table-column
                    width="150">
                    <sc-button
                      theme="primary"
                      >
                      <a :href="props.row.download_url" download class="button-download">Download</a>
                    </sc-button>
                  </sc-table-column>
                </template>

                <template slot="empty">
                  <sc-table-empty />
                </template>
            </sc-table>
          </div>
        </div>
      </div>
    </sc-page-base>
  </div>
</template>

<script>
  import {
    ScButton,
    ScTable,
    ScTableColumn,
    ScTableEmpty,
    ScPageBase,
  } from '@intelipost-js/secure-components';
  
  import { createNamespacedHelpers } from 'vuex';

  const { mapState, mapActions } = createNamespacedHelpers('quote/quotingExtrationTableQuote');

  export default {
    name: 'sc-page-extration-table-quote',
    props: {
    },
    mounted() {
      this.getTableGereratedQuoteContract().then();
    },
    data() {
      return {
        title: 'Tabela de fretes',
      };
    },
    watch: {
    },
    methods: {
      ...mapActions(['getTableGereratedQuoteContract']),
    },
    computed: {
      ...mapState([
        'loading',
        'extrationTable',
      ]),
    },
    components: {
      ScButton,
      ScTable,
      ScTableColumn,
      ScTableEmpty,
      ScPageBase,
    },
  };
</script>

<style lang="scss" scoped>
  .button-download{
    color: #FFFFFF
  }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-quote/features/table-quote/PageExtrationTableQuote.vue?1994a74e